<template>
  <div>
    <el-row class="desc">
      {{ currentPage.page.title }}
    </el-row>
    <el-row class="block">
      <el-row class="title">
        {{ currentPage.page.question }}
      </el-row>
      <el-row
        v-if="answerHeader"
        class="column-header"
      >
        <div class="column">
          <span>{{ this.currentPage.columns[0].questionHeader }}</span>
          <span>{{ this.answerHeader[0] }}</span>
          <span>{{ this.answerHeader[1] }}</span>
        </div>
      </el-row>
      <el-row class="survey-questions">
        <div
          v-for="question in questions"
          :key="question.index"
        >
          <div>
            <RadioBtn
              v-if="(question.controlType == 'RadioBtn' && !question.parentQuestId) || (question.controlType == 'RadioBtn' && question.parentQuestId && showIds.includes(question.findingId)) "
              ref="radioBlock"
              :id="question.id"
              :qfid="question.findingId"
              :condition="question.childQuestDemonstrationCondition"
              :postfix="question.postfix"
              :required="question.required"
              :variants="question.variants"
              :select="question.selectedValue"
              :parent="question.parentQuestId ? true : false"
              :label="question.text"
              @passData="setDataObject"
              :columns="'columns-' + question.variants.length"
            />
            <RadioBtn
              v-if="question.controlType == 'RadioBtn' && question.clinicalLookupCodeControlType && showIds.includes(question.findingId)"
              ref="radioBlock"
              :qfid="question.findingId"
              :id="question.id"
              :postfix="question.lookupPostfix"
              :required="question.required"
              :lookup="question.clinicalLookupCodeControlType ? true : false"
              :variants="question.lookupVariants"
              :select="question.selectedLookupValue"
              :values="valuesLookup"
              :parent="true"
              :label="question.clinicalLookupCodeQuestionText"
              @passData="setDataObject"
              :columns="'columns-' + question.lookupVariants.length"
            />
            <CheckBoxBtn
              v-if="question.controlType == 'CheckBox' && showIds.includes(question.findingId)"
              ref="CheckBox"
              :id="question.id"
              :qfid="question.findingId"
              :condition="question.childQuestDemonstrationCondition"
              :postfix="question.postfix"
              :rows="question.showRowsView"
              :name="question.firstName"
              :name2="question.secondName"
              :names="question.names"
              :required="question.required"
              :variants="question.variants"
              :select="question.selectedValue"
              :parent="question.parentQuestId ? true : false"
              :label="question.text"
              @passData="setDataObject"
              :columns="'columns-' + question.variants.length"
            />
            <TextField
              v-if="(((question.controlType == 'TextInput' || question.controlType == 'NumInput') && showIds.includes(question.findingId)) || ((question.clinicalLookupCodeControlType == 'TextInput' || question.clinicalLookupCodeControlType == 'NumInput') && showLookupIds.includes(question.findingId)))"
              ref="inputBlock"
              :qfid="question.findingId"
              :postfix="question.clinicalLookupCodeControlType ? question.lookupPostfix : question.postfix"
              :lookup="question.clinicalLookupCodeControlType ? true : false"
              :type="question.type"
              :controltype="question.controlType"
              :select="question.clinicalLookupCodeControlType ? question.selectedLookupValue : question.selectedValue"
              :label="question.clinicalLookupCodeControlType ? question.clinicalLookupCodeQuestionText : question.text"
              :flag="question.flag"
              :parent="question.parentQuestId ? true : false"
              :placeholder="question.hint"
              @passData="setDataObject"
              :required="question.required"
            />
          </div>
        </div>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import RadioBtn from "./form/RadioBtn";
import store from "../../store";
import TextField from "./form/TextField";
import CheckBoxBtn from "./form/CheckBoxBtn";
import {AND_DELIMITER, DELIMITER} from '../../utils/consts';

export default {
  name: 'SurveyComponent',
  components: {TextField, RadioBtn, CheckBoxBtn},
  data: function () {
    return {
      surveyData: [],
      currentQuestion: 0,
      pages: null,
      questionAnswerVariants: [],
      clinicalLookupCodeAnswerVariants: [],
      questions: [],
      checkQuestion: [],
      check: [],
      fields: [],
      savedFields: [],
      questionsData: [],
      findingValue: '',
      currentPage: {},
      toggle: true,
      showIds: [],
      showLookupIds: [],
      showError: false,
      values: {},
      requiredFields: [],
      valuesLookup: [],
      answerHeader: '',
    };
  },
  props: {
    demonstrationCondition: {
      type: String,
      default: () => {
        return '';
      }
    },
    data: {
      type: Array,
      default: () => {
        return [];
      }
    },
    index: {
      type: Number,
      default: () => {
        return 0;
      }
    },
  },
  created() {
    this.savedFields = store.getters.surveyData;
    this.getCurrentPage(this.index);
  },
  methods: {
    async forceRerender() {
      this.renderComponent = false;
      await this.$nextTick();
      this.renderComponent = true;
    },
    getCurrentPage(index) {
      this.currentPage = this.data[index];
      if (this.currentPage.columns.length !== 0) {
        this.$set(this, 'answerHeader', this.currentPage.columns[0].answerHeader.split('|'));
      }
      this.getQuestions();
    },
    sendValidateFields() {
      let errorFields = [];
      this.requiredFields.forEach((value) => {
        if (Object.prototype.hasOwnProperty.call(this.values, value) && !this.values[value]) {
          errorFields.push(value);
        }
      });
      let error = false
      if (errorFields.length !== 0) {
        Object.values(this.$refs).forEach((block) => {
          block.forEach((component) => {
            if (errorFields.includes(component.modelName)) {
              this.$set(component, 'showError', true);
              error = true
            }
          });
        });
        return error;
      }
      return false;
    },
    setDataObject(data) {
      let childQuestions = this.questions.filter(el => el.parentQuestId === data.id),
          currentQuestion = this.questions.filter(el => el.findingId === data.data.findingId),
          parentQuestion = [];

      if (currentQuestion.length !== 0) {
        if(Object.prototype.hasOwnProperty.call(currentQuestion[0], 'parentQuestId')) {
          parentQuestion = this.questions.filter(el => el.id === currentQuestion[0].parentQuestId);
        }
      }

      if (data.condition && data.condition == data.data.yNResultFlag) {
        if (currentQuestion[0].clinicalLookupCodeDemonstrationCondition && currentQuestion[0].clinicalLookupCodeDemonstrationCondition == data.data.yNResultFlag) {
          if (!this.showLookupIds.includes(data.data.findingId)) this.showLookupIds.push(data.data.findingId);
        }
        if (!this.showIds.includes(data.data.findingId)) this.showIds.push(data.data.findingId);
        if (childQuestions.length !== 0) {
          childQuestions.forEach((value) => {
            if(value.parentQuestId && value.clinicalLookupCodeDemonstrationCondition) {
              if (this.fields.length !== 0) {
                let savedParent = this.fields.filter(el => (value.findingId === el.findingId));
                if (savedParent && savedParent.yNResultFlag == value.clinicalLookupCodeDemonstrationCondition) {
                  if (!this.showLookupIds.includes(data.data.findingId)) this.showLookupIds.push(data.data.findingId);
                }
              } else {
                if (value.clinicalLookupCodeDemonstrationCondition === 'N') {
                  if (!this.showLookupIds.includes(data.data.findingId)) this.showLookupIds.push(data.data.findingId);
                }
              }
            }
            if (!this.showIds.includes(value.findingId)) this.showIds.push(value.findingId);
          });
        }
      } else {
        if (data.data.ClinicalLookupCode) {
          if (currentQuestion[0].childQuestDemonstrationCondition !== data.data.yNResultFlag) {
            this.deleteItem(data.data.findingId)
          }
        } else {
          if (currentQuestion.length !== 0) {
            if (currentQuestion[0].childQuestDemonstrationCondition && currentQuestion[0].childQuestDemonstrationCondition !== data.data.yNResultFlag) {
              if (childQuestions.length !== 0) {
                childQuestions.forEach((value) => {
                  if (value.clinicalLookupCodeDemonstrationCondition) {
                    this.deleteLookupItem(value.findingId);
                  }
                  this.deleteItem(value.findingId)
                });
              }
            }
            if (parentQuestion.length !== 0) {
              let parentFieldData = [];
              if (this.fields.length !== 0) {
                parentFieldData = this.fields.filter(el => el.findingId === parentQuestion[0].findingId);
              } else if (this.savedFields.length !== 0) {
                parentFieldData = this.savedFields[this.index].filter(el => el.findingId === parentQuestion[0].findingId);
              }
              if (parentFieldData && currentQuestion[0].childQuestDemonstrationCondition && parentFieldData[0].yNResultFlag !== currentQuestion[0].childQuestDemonstrationCondition) {
                this.deleteItem(currentQuestion[0].findingId)
              }
            } else {
              if (currentQuestion[0].controlType === 'RadioBtn') {
                this.deleteItem(currentQuestion[0].findingId)
              }
            }
            if (currentQuestion[0].clinicalLookupCodeDemonstrationCondition && currentQuestion[0].clinicalLookupCodeDemonstrationCondition !== data.data.yNResultFlag) {
              this.deleteLookupItem(currentQuestion[0].findingId);
            }
          }
        }
      }
      Object.assign(this.values, {[data.model]: data.data.yNResultFlag});
      if (this.savedFields.length !== 0 && Object.prototype.hasOwnProperty.call(this.savedFields, this.index)) {
        var updatedData = [];
        let changedData = false;
        this.savedFields[this.index].forEach((value) => {
          if(value.findingId == data.data.findingId) {
            updatedData.push(data.data)
            changedData = true
          } else {
            updatedData.push(value)
          }
        });
        if (!changedData) {
          updatedData.push(data.data);
        }
        this.savedFields[this.index] = updatedData
        this.$emit('sendFields', updatedData);
      } else {
        if (this.fields.length !== 0 ) {
          let changedData = false;
          this.fields.forEach((value, key) => {
            if (value.findingId == data.data.findingId) {
              if(data.data.findingType == 'CheckBox' && !data.model) {
                this.fields.splice(key, 1);
              } else {
                if (currentQuestion[0].childQuestDemonstrationCondition && currentQuestion[0].childQuestDemonstrationCondition !== data.data.yNResultFlag) {
                  if (childQuestions.length !== 0) {
                    childQuestions.forEach((value) => {
                      let index = this.fields.indexOf(value.findingId)
                      if (index !== -1) this.fields.splice(index, 1);
                    });
                  }
                }
                this.fields[key] = data.data
              }
              changedData = true
            }
          });
          if (!changedData) {
            this.fields.push(data.data);
          }
        } else {
          this.fields.push(data.data);
        }
        this.$set(this, 'checkQuestion', data.data);
        this.$emit('sendFields', this.fields);
      }
    },
    deleteItem(id) {
      let qIndex = this.showIds.indexOf(id)
      if (qIndex !== -1) this.showIds.splice(qIndex, 1);
    },
    deleteLookupItem(id) {
      let lIndex = this.showLookupIds.indexOf(id)
      if (lIndex !== -1) this.showLookupIds.splice(lIndex, 1);
    },
    getQuestions() {
      this.currentPage.questions.forEach((value) => {
        this.prepareQuestion(value, this.currentPage.questions);
      });
    },
    prepareQuestion(question, questions) {
      if (question.parentQuestId) {
        var parentQuestion = questions.find(el => el.id === question.parentQuestId);
        this.$set(question, 'flag', parentQuestion.childQuestDemonstrationCondition);
      }
      var childQuestions = questions.filter(el => question.id === el.parentQuestId);

      if (question.controlType === 'RadioBtn') {
        this.questionAnswerVariants = this.prepareVariants(question, true);
        this.$set(question, 'variants', this.questionAnswerVariants);
        let name = question.findingId + '_yesNoResult',
            lookupName = question.findingId + '_clinicalLookupCodeResult';
        Object.assign(this.values, {[name]: ''});
        if (question.required) {
          this.requiredFields.push(name)
        }
        this.$set(question, 'postfix', 'yesNoResult');

        if (question.clinicalLookupCodeControlType) {
          this.clinicalLookupCodeAnswerVariants = this.prepareVariants(question, false, true);
          this.$set(question, 'lookupVariants', this.clinicalLookupCodeAnswerVariants);
          if (question.required) {
            this.requiredFields.push(lookupName);
          }
          Object.assign(this.values, {[lookupName]: ''});
          this.$set(question, 'lookupPostfix', 'clinicalLookupCodeResult');
        }
        if (!question.flag && !question.lookupPostfix) {
          if (!this.showIds.includes(question.findingId)) this.showIds.push(question.findingId);
        }

        if (this.savedFields.length !== 0) {
          this.$set(question, 'selectedValue', '');
          this.$set(question, 'selectedLookupValue', '');
          if (Object.prototype.hasOwnProperty.call(this.savedFields, this.index) ) {
            this.savedFields[this.index].forEach((value) => {
              if(question.findingId == value.findingId) {
                this.$set(question, 'selectedValue', value.yNResultFlag);
                Object.assign(this.values, {[name]: value.yNResultFlag});
                if (parentQuestion) {
                  if (parentQuestion.childQuestDemonstrationCondition == value.ClinicalLookupCode) {
                    if (!this.showIds.includes(value.findingId)) this.showIds.push(value.findingId);
                  }
                }
                if (question.childQuestDemonstrationCondition && question.childQuestDemonstrationCondition == value.yNResultFlag) {
                  if (childQuestions.length !== 0) {
                    childQuestions.forEach((val) => {
                      if (!this.showIds.includes(val.findingId)) this.showIds.push(val.findingId);
                    });
                  }
                  if (!this.showIds.includes(question.findingId)) this.showIds.push(question.findingId);
                }
                if (question.lookupPostfix) {
                  this.$set(question, 'selectedLookupValue', value.ClinicalLookupCode);
                  Object.assign(this.values, {[lookupName]: value.ClinicalLookupCode});
                }
              }
            });
          }
        }
      }

      if (question.controlType === 'TextInput' || question.controlType === 'NumInput') {
        let name = question.findingId + '_commentResult';
        if (question.required) {
          this.requiredFields.push(name)
        }
        Object.assign(this.values, {[name]: ''});

        let contentType = 'text';
        if (question.controlType === 'NumInput') {
          contentType = 'number';
        }
        this.$set(question, 'type', contentType);
        this.$set(question, 'postfix', 'commentResult');
        if (this.savedFields.length !== 0) {
          this.$set(question, 'selectedValue', '');
          if (Object.prototype.hasOwnProperty.call(this.savedFields, this.index) ) {
            this.savedFields[this.index].forEach((value) => {
              if(question.findingId == value.findingId) {
                this.$set(question, 'selectedValue', value.findingValue);
                Object.assign(this.values, {[name]: value.findingValue});
              }
            });
          }
        }
      }

      if (question.controlType === 'CheckBox') {
        this.$set(question, 'showOneOfView', false);
        this.$set(question, 'showRowsView', false);

        let findings = question.findingId.split(AND_DELIMITER);
        let firstName =
            findings[0] +
            '_yesNoResult' +
            '_unifyingGroup' +
            (question.unifyingGroup ? ('_' + question.unifyingGroup) : '_Common');
        let secondName = null,
            names=[],
            lookupName = question.findingId + '_clinicalLookupCodeResult';

        if (question.required) {
          this.requiredFields.push(firstName)
        }

        if (question.clinicalLookupCodeControlType) {
          if (question.required) {
            this.requiredFields.push(lookupName);
          }
          Object.assign(this.values, {[lookupName]: ''});
          this.$set(question, 'lookupPostfix', 'clinicalLookupCodeResult');
        }

        if (question.clinicalLookupCodeControlType) {
          if (question.clinicalLookupCodeControlType === 'TextInput' || question.clinicalLookupCodeControlType === 'NumInput') {
            let contentType = 'text';
            if (question.clinicalLookupCodeControlType === 'NumInput') {
              contentType = 'number';
            }
            this.$set(question, 'type', contentType);
            if (question.required) {
              this.requiredFields.push(lookupName);
            }
            Object.assign(this.values, {[lookupName]: ''});
            this.$set(question, 'lookupPostfix', 'clinicalLookupCodeResult');
          }
        }

        if (this.savedFields.length !== 0) {
          this.$set(question, 'selectedValue', false);
          this.$set(question, 'selectedLookupValue', '');
          if (Object.prototype.hasOwnProperty.call(this.savedFields, this.index) ) {
            this.savedFields[this.index].forEach((value) => {
              if(question.findingId == value.findingId) {
                if (value.yNResultFlag == 'Y') {
                  this.$set(question, 'selectedValue', true);
                }
                if (parentQuestion.length !== 0) {
                  let savedParent = this.savedFields[this.index].filter(el => (value.findingId === el.findingId));
                  if (savedParent.length !== 0 && savedParent[0].yNResultFlag == question.clinicalLookupCodeDemonstrationCondition) {
                    if (!this.showLookupIds.includes(value.findingId)) this.showLookupIds.push(value.findingId);
                  }
                }
                if (question.childQuestDemonstrationCondition && question.childQuestDemonstrationCondition == value.yNResultFlag) {
                  if (childQuestions.length !== 0) {
                    childQuestions.forEach((val) => {
                      if (!this.showIds.includes(val.findingId)) this.showIds.push(val.findingId);
                    });
                  }
                  if (!this.showIds.includes(question.findingId)) this.showIds.push(question.findingId);
                }
                if (question.lookupPostfix) {
                  this.$set(question, 'selectedLookupValue', value.findingValue);
                  Object.assign(this.values, {[lookupName]: value.findingValue});
                }
              }
            });
          }
        }

        if (!parentQuestion) {
          if (!this.showIds.includes(question.findingId)) this.showIds.push(question.findingId);
        }

        if (findings.length > 1) {
          this.$set(question, 'showRowsView', true);
          firstName = findings[0] + '_firstYesResult'
          secondName = findings[1] + '_secondYesResult';
          let fid1 = question.findingId.split('&')[0],
              fid2 = question.findingId.split('&')[1],
              value1 = false,
              value2 = false;

          if (this.savedFields.length !== 0) {
            if (Object.prototype.hasOwnProperty.call(this.savedFields, this.index) ) {
              this.savedFields[this.index].forEach((value) => {
                if (fid1 == value.findingId && value.yNResultFlag == 'Y') {
                  value1 = true;
                }
                if (fid2 == value.findingId && value.yNResultFlag == 'Y') {
                  value2 = true;
                }
              });
            }
          }

          names.push({[firstName]: value1, fid: question.findingId.split('&')[0], name: firstName});
          names.push({[secondName]: value2, fid: question.findingId.split('&')[1], name: secondName});
          this.$set(question, 'names', names);
        } else if (question.unifyingGroup) {
          this.$set(question, 'showOneOfView', true);
        }

        let questionYesVariant = this.prepareVariants(question);
        this.$set(question, 'variants', questionYesVariant);
        this.$set(question, 'postfix', 'clinicalLookupCodeResult');
      }

      this.questions.push(question);
    },
    prepareVariants(question, isYesNo, isForClinicalLookupCode) {
      const variants = [];
      if (isYesNo) {
        const yesNoLabels = question.controlValue.split(DELIMITER);
        variants.push({label: yesNoLabels[0], value: "Y"});
        variants.push({label: yesNoLabels[1], value: "N"});
        return variants;
      }

      let values = isForClinicalLookupCode ? question.clinicalLookupCodeControlValue.split(DELIMITER) : question.controlValue.split(DELIMITER);
      let labels = {};

      if ((question.findingId.split(DELIMITER).length === 2) && (question.controlType === 'CheckBox')) {
        values.forEach((value) => {
          let variant = {label: value, value: 'YES'};
          variants.push(variant);
        });
        return variants;
      }
      else {
        labels = question.clinicalLookupCodeControlValueLabel && question.clinicalLookupCodeControlValueLabel.split(DELIMITER);
      }

      if (values.length === 1) {
        let variant = {
          label: question.clinicalLookupCodeControlValueLabel ? labels[0] : values[0],
          value: question.clinicalLookupCodeControlValueLabel ? values[0] : "Y"
        };
        variants.push(variant);
      }
      else {
        values.forEach((value, index) => {
          let variant = {label: labels[index], value: value};
          variants.push(variant);
        });
      }

      return variants;
    }
  }
};
</script>
